import React, {useState} from 'react';
import ModalShumaFilesListView from './ModalShumaFilesList-view';

const ModalShumaFilesList = ({
                               shumaId,
                               firmShumaID,
                               getFileList
                             }) => {
  const [data, setData] = useState('');
  const files = data.fileList || [];

  const updateList = () => {
    getFileList({shumaId})
      .then(body => setData(body))
  };

  return (
    <ModalShumaFilesListView
      shumaId={shumaId}
      firmShumaID={firmShumaID}
      files={files}
      updateList={updateList}
    />
  );
};

export default ModalShumaFilesList;